import { render, staticRenderFns } from "./DeclarationsMenuIcon.vue?vue&type=template&id=1d0fd7b7"
import script from "./DeclarationsMenuIcon.vue?vue&type=script&lang=js"
export * from "./DeclarationsMenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports